import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../../Block';
import PropTypes from 'prop-types';
import { Loader } from "../../../loader/Loader";
import ShowItem from "../../../ShowItem";
import {formatNumber, formatPercent, formatPrice} from "../../../Format";

const fromCompositeToArr = (composite) => {
  const arr = Object.keys(composite).map((x)=>parseInt(x)).sort()
  return arr.map((elt,i) => {
    let obj = composite[elt.toString()]
    let res = {
      from: elt,
      value: parseFloat(Object.values(obj)[0]),
      model: Object.keys(obj)[0]
    }
    if (arr[i + 1]) {
      res.to = arr[i + 1]
    }
    return res
  })
}

const MrgFields = ({publisher}) => {
  const { t } = useTranslation();

  const compositeEltToLabel = (elt) => {
    let res = `${formatNumber(elt.from)}`
    if( elt.to ) {
      res += ` - ${formatNumber(elt.to)}`
    } else {
      res += '+'
    }
    res += ` : ${elt.model} / ${formatPrice(elt.value)}\n`
    return res
  }

  const compositeStrings = (composite) => (fromCompositeToArr(composite).map(compositeEltToLabel))

  return(<>
      <ShowItem label={t('publisher.model')} value={publisher.mrg_model}/>
      { publisher.mrg_model === "cpm" &&
        <ShowItem label="CPM" value={formatPrice(publisher.mrg_value)}/>
      }
      { publisher.mrg_model === "composite" &&
        <ShowItem label="CPM" value={compositeStrings(publisher.mrg_value)}/>
      }
      { publisher.mrg_model !== "cpm" &&
        <ShowItem label={t('publisher.cpm_equivalent')} value={formatPrice(publisher.mrg_cpm_equivalent)}/>
      }
      <ShowItem label={t('publisher.monthly_mrg')} value={formatPrice(publisher.mrg_compute)}/>
    </>
  )
}

const BillingBlock = ({publisher, ...props}) => {
  const { t } = useTranslation();
  const loaderProps = { success: props.isSuccess, error: props.isError, retry: props.retry }

  //Have to fill with every billing possibilities, cpm, composite and fix

  return (
    <Block title={t('publisher.general.billing')}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <ShowItem label={t('publisher.rev_sharing')} value={formatPercent(publisher.rev_share)}/>
        <MrgFields publisher={publisher} />
        <ShowItem label={t('publisher.billing_entity')} value={publisher.billing_entity}/>
        <ShowItem label={t('publisher.billing_manager')} value={publisher.billing_manager}/>
        <ShowItem label={t('publisher.billing_address')} value={publisher.billing_address}/>
      </Loader>
    </Block>
  )
}

BillingBlock.propTypes = {
  publisher: PropTypes.object
}

export default BillingBlock
